import { inject, injectable } from 'inversify';
import { LearningGuideMenuItemState } from '../stores/LearningGuideMenuItemState.store';
import { STARTING_GUIDE_TYPES } from '..';

@injectable()
export class LearningGuideMenuItemService {
  private _menuItemState: LearningGuideMenuItemState;

  public constructor(
    @inject(STARTING_GUIDE_TYPES.LearningGuideMenuItemState) learningGuideMenuItemState: LearningGuideMenuItemState
  ) {
    this._menuItemState = learningGuideMenuItemState;
  }

  public blinkMenuItem(): void {
    this._menuItemState.setBlinking(true);
    setTimeout(() => {
      this._menuItemState.setBlinking(false);
    }, 3000);
  }

  public isMenuItemStateBlinking(): boolean {
    return this._menuItemState.isBlinking;
  }
}
